import { createBrowserHistory, History } from 'history';
import { RouteConfig } from 'react-router-config';
import { PrivateRoute } from './components/core/private-route.component';
import { PublicRoute } from './components/core/public-route.component';
import Dashboard from './pages/Dashboard/dashboard.component';
import SigninComponent from './pages/SignIn/signin.component';
// import SignUpComponent from './pages/SignUp/signup.component';
import EFileAnalyzerTool from './pages/Tools/EFileAnalyzer/efile-analyzer-tool.component';
import RealSizeViewerTool from './pages/Tools/RealSizeViewer/realsize-viewer-tool.component';
import GeocoderTool from './pages/Tools/Geocoder/geocoder-tool.components';
import { clientRoutes } from './shared/constants';
import { Redirect, Switch } from 'react-router-dom';
import UnitConverterTool from './pages/Tools/UnitConverter/unit-converter-tool.component';
import VolumetricWeightTool from './pages/Tools/VolumetricWeight/volumetric-weight-tool.component';

export interface IAppRouteConfig extends RouteConfig {
	key?: string;
	render?: () => any;
}

export interface IHistoryState {
	showSideBar: boolean;
}

export const AppRoutes = () => {
	return (
	<>
		<Switch>
			<PublicRoute path={clientRoutes.signIn} component={SigninComponent} />
			{/* <PublicRoute path={clientRoutes.signUp} component={SignUpComponent} /> */}
			<PrivateRoute path={clientRoutes.dashboard} component={Dashboard} />
			<PrivateRoute path={clientRoutes.efileAnalyzer} component={EFileAnalyzerTool} />
			<PrivateRoute path={clientRoutes.realSizeViewer} component={RealSizeViewerTool} />
			<PrivateRoute path={clientRoutes.geocoder} component={GeocoderTool} />
			<PrivateRoute path={clientRoutes.volumetricWeight} component={VolumetricWeightTool} />
			<PrivateRoute path={clientRoutes.unitConverter} component={UnitConverterTool}/>
			<Redirect to={clientRoutes.signIn} />
		</Switch>
	</>
)}

export const history = createBrowserHistory({
	basename: '/',
}) as History<IHistoryState>;
